







































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import ModalCustomer from "@/components/Modal/ModalCustomer.vue";
import { CustomerSchema } from "@/models/customer_schema";
import { SalesRegionsStringType } from "@/models/map/region_type";
import { SalesContactSchema } from "@/models/sales_contact_schema";
import moment from "moment";
import CustomerService from "@/services/customer_service";
import SalesPerson from "@/components/Sidebar/Customer/SalesPerson.vue";
import TypeToViewMap, { CustomerStatus, CustomerType } from "@/models/customer";
import mapboxgl from "mapbox-gl";
import { EventBus } from "@/events/index";
import { StoreModule } from "@/store/types";
import { UserGetters } from "@/store/modules/user/types";
import { namespace } from "vuex-class";
import { Roles } from "@/models/roles";
import ModalActivityNote from "@/components/Modal/ModalActivityNote.vue";
import {
  CustomerActions,
  CustomerGetters,
} from "@/store/modules/customer/types";
import { Layers } from "@/models/map/layers";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import SalesYOY from "@/components/Sidebar/Customer/SalesYOY.vue";
import Discounts from "@/components/Sidebar/Customer/Discounts.vue";

@Component({
  components: {
    ModalCustomer,
    ModalActivityNote,
    SalesPerson,
    SalesYOY,
    Discounts,
  },
})
export default class Customer extends Vue {
  @Prop() _id!: CustomerSchema["_id"];
  @Prop() customer_name!: CustomerSchema["customer_name"];
  @Prop() store_name!: CustomerSchema["store_name"];
  @Prop() trade_only!: CustomerSchema["trade_only"];
  @Prop() address?: CustomerSchema["address"];
  @Prop() location!: CustomerSchema["location"];
  @Prop() phone?: CustomerSchema["phone"];
  @Prop() website_url?: CustomerSchema["website_url"];
  @Prop() email?: CustomerSchema["email"];
  @Prop() multiplier?: CustomerSchema["multiplier"];
  @Prop() hide_from_map?: CustomerSchema["hide_from_map"];
  @Prop() sales_region?: SalesRegionsStringType;
  @Prop() customer_type?: CustomerSchema["customer_type"];
  @Prop() status?: CustomerSchema["status"];
  @Prop() brands_carried!: CustomerSchema["brands_carried"];
  @Prop() business_info!: CustomerSchema["business_info"];
  @Prop() sales_contacts?: SalesContactSchema[];
  @Prop() customer_since?: string;
  @Prop() created_at!: string;
  @Prop() contacts!: SalesContactSchema[];
  @Prop() activityUpdate?: string | false | undefined;
  @Prop() map!: mapboxgl.Map;
  protected Roles = Roles;
  protected singleView = false;
  protected customerService = new CustomerService();
  protected CustomerStatus = CustomerStatus;
  protected Layers = Layers;
  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;
  @(namespace(StoreModule.Customer).Action(CustomerActions.DeleteCustomer))
  deleteCustomer!: (id: string) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetActiveView))
  activeView;
  @(namespace(StoreModule.Customer).Getter(CustomerGetters.GetAllCustomers))
  customers;

  created() {
    if (this.$route.params.id) {
      this.singleView = true;
    }
  }

  get brands(): string {
    let brandString = "";
    if (this.brands_carried && this.brands_carried.length > 0) {
      this.brands_carried.forEach((brand, i) => {
        if (i === this.brands_carried.length - 1) {
          brandString += brand.display_name;
        } else {
          brandString += brand.display_name + ", ";
        }
      });
    } else {
      brandString = "N/A";
    }
    return brandString;
  }

  get showNewLabel(): boolean {
    let show;
    if (this.customer_since) {
      show =
        this.status === CustomerStatus.Current &&
        moment().diff(moment(this.customer_since), "years", true) <= 1;
    }
    return show;
  }

  get salesVolume(): CustomerSchema["business_info"]["sales_volume"] {
    return this.business_info.sales_volume.sort((a, b) => a.year - b.year);
  }

  get labelColor(): string {
    let label;
    switch (this.status) {
      case CustomerStatus.Current:
        label = "black uk-label";
        break;
      case CustomerStatus.PriorityA:
        label = "uk-label purple";
        break;
      case CustomerStatus.PriorityB:
        label = "uk-label orange";
        break;
      case CustomerStatus.FrankfordTarget:
        label = "uk-label blue";
        break;
      case CustomerStatus.Lost:
        label = "uk-label red";
        break;
    }
    return label;
  }

  protected websiteLink(url: string): string {
    if (url.startsWith('www')) {
        url = 'http://' + url;
      }
    return `<a href='${url}' target="_blank">${url}</a>`;
  }

  protected triggerActivityNote(id: string) {
    const props = {};
    const options = {
      adaptive: true,
      width: 860,
      height: "auto",
      scrollable: true,
    };
    this.$modal.show(
      ModalActivityNote,
      { ...props, customerId: id },
      { ...options }
    );
  }

  protected goToRep(): void {
    this.$router.push({ path: "/", query: { region: this.sales_region } });
  }

  protected get customerSince(): string {
    let dateString;
    if (this.customer_since) {
      dateString = moment(this.customer_since).format("MMM Do, YYYY");
    } else {
      dateString = "N/A";
    }
    return dateString;
  }

  protected get customerAdded(): string {
    return moment(this.created_at).format("MMM Do, YYYY");
  }

  protected triggerCustomer() {
    this.$modal.show(
      ModalCustomer,
      { isEdit: true, data: this.$props },
      { adaptive: true, width: 860, height: "auto", scrollable: true }
    );
  }

  protected triggerSalesPerson() {
    this.$modal.show(
      SalesPerson,
      { isEdit: true, data: this.$props },
      { adaptive: true, width: 1120, height: "auto", scrollable: true }
    );
  }

  protected triggerSalesYOY() {
    this.$modal.show(
      SalesYOY,
      { isEdit: true, data: this.$props },
      { adaptive: true, width: 1120, height: "auto", scrollable: true }
    );
  }

  protected triggerDiscounts() {
    this.$modal.show(
      Discounts,
      { isEdit: true, data: this.$props },
      { adaptive: true, width: 1120, height: "auto", scrollable: true }
    );
  }

  private price = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  private decimal = new Intl.NumberFormat("en-US", {
    minimumIntegerDigits: 1,
    minimumFractionDigits: 2,
  });

  protected yoyCalc(index: number): InnerHTML {
    let html;
    const currentObj = this.salesVolume[index];
    const prevObj = this.salesVolume[index - 1]
      ? this.salesVolume[index - 1]
      : 0;
    if (prevObj) {
      const num = (currentObj.amt / prevObj.amt - 1) * 100;
      if (num < 0) {
        const roundedNum = num.toFixed(2);
        html = `<span class="small-padding"><img src="${require("../../../assets/img/iconredarrow.jpg")}" width=18px /></span> ${roundedNum}% YOY`;
      } else {
        const roundedNum = num.toFixed(2);
        html = `<span class="small-padding"><img src="${require("../../../assets/img/icongreenarrow.jpg")}" width=18px /></span> ${roundedNum}% YOY`;
      }
    }
    return html;
  }

  protected async removeCustomer(): Promise<void> {
    await this.deleteCustomer(this._id);
    if (this.singleView) {
      this.$router.go(-1);
    }
    EventBus.$emit("deleteCustomer", this._id);
  }

  protected handleSelection(): void {
    if (!this.singleView) {
      this.$router.push({ path: "/customers/" + this._id });
    } else {
      EventBus.$emit("moveToCustomer");
    }
  }
}
